import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { CheckRequestDetail } from "@/pages/requests/check/schema/check-requests.schema";
import { TransferRequestDetail } from "@/pages/requests/transfer/schema/transfer-requests.schema";

interface Props {
  request?:
    | CashRequestDetail
    | CheckRequestDetail
    | TransferRequestDetail
    | null;
  type?: string;
}

export const RequestSectionHeaderTitle = ({ request, type }: Props) => {
  return request?.id
    ? `Solicitud de ${type} N°: ${request.id}`
    : `Solicitud de ${type}`;
};
